import { Injectable } from '@angular/core';

import { LoginPayload } from '@modules/core/interfaces';
import { SignInResponseDTO } from '@paymash/local-sdk/dto/response';
import { SignInRequestDTO } from '@paymash/local-sdk/dto/request';
import { Auth } from '@models';

@Injectable({
  providedIn: 'root',
})
export class SignInMapper {
  public mapToEntity(dto: SignInResponseDTO): Auth {
    return {
      accessToken: dto.accessToken,
      refreshToken: dto.refreshToken,
    };
  }

  public mapToDTO(entity: LoginPayload): SignInRequestDTO {
    return {
      email: entity.email,
      password: entity.password,
    };
  }
}
